import { combineReducers } from "redux";
import language from "./language";
import location from "./location";
import device from "./device";
import LagunaBeachside from "./laguna-beachside";
import LagunaSeasideResidences from "./laguna-seaside-residences";
import PhuketSkypark from "./phuket-skypark";
import phuketLagunaPark2 from "./phuket-laguna-park-2";
import phuketLagunaVillageResidences from "./phuket-laguna-village-residences";
import phuketDusitDeluxePoolVilla from "./phuket-dusit-deluxe-pool-villa";
import previewTrip from "./preview-trip";
import home from "./home";

export default combineReducers({
  language,
  location,
  device,
  "laguna-beachside": LagunaBeachside,
  "laguna-seaside-residences-dev": LagunaSeasideResidences,
  "laguna-seaside-residences": LagunaSeasideResidences,
  "phuket-skypark": PhuketSkypark,
  "phuket-laguna-park-2": phuketLagunaPark2,
  "phuket-laguna-village-residences": phuketLagunaVillageResidences,
  "phuket-dusit-deluxe-pool-villa": phuketDusitDeluxePoolVilla,
  home: home,
  "preview-trip": previewTrip,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js